module.exports = __webpack_public_path__ + "img/screenshot (8).a53f7b03.jpg";